import axios from 'axios';
import { getDeviceName, setDeviceId } from '../../utils';
import { UserVisitGetAllQuery, UserVisitGetOneQuery } from '../../types';

class UserVisitsService {
  create = async () => {
    const deviceName = getDeviceName();

    const { data } = await axios.post('/user-visits', { deviceName });
    setDeviceId(data.deviceId);
  };

  getAll = (props: any) => axios.get<UserVisitGetAllQuery>('/user-visits', props);

  get = (id: string) => axios.get<UserVisitGetOneQuery>(`/user-visits/${id}`);
}

export const userVisitsService = new UserVisitsService();
